var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.computedSrc,"alt":_vm.dataAlt}})
}
var staticRenderFns = []

export { render, staticRenderFns }